<template>
  <AppPopover
    v-if="manualTimeEntryRequests.length > 0"
    ref="AppPopover"
    placement="top"
    popover-container-classes=""
    lazy
  >
    <template #body>
      <div class="p-10">
        <div class="pr-20">
          <strong class="pr-5">
            <i class="hi hi-warning text-orange mr-10"></i>
            Manual time
          </strong>
          {{ sumDuration(manualTimeEntryRequests) | formatDuration }}
        </div>
        <div class="marketing-text-gray-light">(Pending Approval)</div>
      </div>
    </template>
    <template #trigger>
      <i class="hi hi-info-filled text-lighter ml-5 cursor-pointer"></i>
    </template>
  </AppPopover>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ManualTimeEntryRequestWeeklyListPopover',
  props: {
    manualTimeEntryRequests: {
      type: Array,
      required: true,
    },
  },
  computed: {
    ...mapGetters(['sumDuration']),
  },
};
</script>
